import module from 'nominas/nomina/module.js'

const schema = {
  colaboradores: {
    importe: 'number',
    comision_importe: 'number',
    comision_porcentaje: 'number',
    neto: 'number',
    incapacidades: {
      dias_pagados: 'number',
      importe: 'number',
    },
    total_prestamos: 'number',
    total_servicios: 'number',
    deducciones: {
      dias: 'number',
      exento: 'number',
      gravado: 'number',
      horas: 'number',
      id_concepto: 'number',
      importe: 'number',
      impuesto_estatal: 'number',
      calculable: 'boolean',
    },
    percepciones: {
      dias: 'number',
      exento: 'number',
      gravado: 'number',
      horas: 'number',
      id_concepto: 'number',
      importe: 'number',
      impuesto_estatal: 'number',
      calculable: 'boolean',
    },
    acumulado: {
      anual: {
        percepciones: {
          id_concepto: 'number',
          importe: 'number',
          gravado: 'number',
        },
        deducciones: {
          id_concepto: 'number',
          importe: 'number',
          gravado: 'number',
        },
      },
      mensual: {
        subsidioDeterminado: 'number',
        impuestoDeterminado: 'number',
        subsidioCausado: 'number',
        impuestoCausado: 'number',
        impuestoAcumulado: 'number',
        percepciones: {
          id_concepto: 'number',
          importe: 'number',
          gravado: 'number',
        },
        deducciones: {
          id_concepto: 'number',
          importe: 'number',
          gravado: 'number',
        },
      },
    },
    prestamos: {
      abono: 'number',
      abonoInteres: 'number',
      creditoId: 'number',
      conceptoId: 'number',
      descuentoId: 'number',
      id: 'number',
      importe: 'number',
      fechaInicial: 'date',
      tipoDescuentoId: 'number',
      tipoDeduccion: '',
      totalAbonos: 'number',
      totalAbonosInteres: 'number',
      valorDeduccion: 'number',
      valorDeduccionInteres: 'number',
    },
    config: {
      absorber_cuota_obrera: 'number',
      absorber_cuota_patronal: 'number',
      absorber_impuesto_estatal: 'number',
      absorber_isr: 'number',
      calculo_mensual_acumulado: 'boolean',
      aguinaldo_exento: 'number',
      asimilados_acumulado: 'number',
      carga_social_pendiente: 'number',
      clase_prima_riesgo: 'number',
      cobro_carga_social: 'boolean',
      dias_carga_social: 'number',
      dias_pendientes_incapacidad: 'number',
      estrategiaId: 'number',
      fecha_baja: 'date',
      fecha_imss_alta: 'date',
      fecha_imss_baja: 'date',
      fecha_ingreso: 'date',
      fecha_suspension: 'date',
      fonacot_pendiente: 'number',
      fonacot_pendiente_saldo: 'number',
      id_estado: 'number',
      id_regimen_fiscal: 'number',
      id_tipo_nomina: 'number',
      id_tipo_pension_alimenticia: 'number',
      infonavit_deduccion_valor: 'number',
      infonavit_pendiente: 'number',
      infonavit_pendiente_saldo: 'number',
      isr_acumulado: 'number',
      nominaOrdinaria: 'boolean',
      prima_riesgo: 'number',
      prima_vacacional_exento: 'number',
      reparto_utilidades_exento: 'number',
      salario_diario: 'number',
      salario_diario_integrado: 'number',
      salario_mensual: 'number',
      subsidio_acumulado: 'number',
      pension_alimenticia_valor: 'number',
      tarifa: 'number',
      ultima_nomina_ordinaria_calculada: 'boolean',
    },
  },
}

export default class NominasNominaCalculoColaboradoresService {
  constructor ($http) {
    this.$http = $http
  }

  get (idProyecto, idNomina, config) {
    return this.$http.get('/api/nominas/nomina/calculo/colaboradores', {
      params: {
        id_proyecto: idProyecto,
        id_nomina: idNomina,
        calcular_aguinaldo: (config && config.calcular_aguinaldo && 1) || 0,
        calcular_viaticos: (config && config.calcular_viaticos && 1) || 0,
      },
      schema,
    })
  }
}

module.service('NominasNominaCalculoColaboradores', NominasNominaCalculoColaboradoresService)



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Calculo/Colaboradores.js